<template>
    <div id="cateId">hello</div>
</template>

<script>
    export default {

    }
</script>

<style scoped>

</style>
